import ComponentModule from '../component-module';
import StorageManager, { LocalStorageManager } from '../storage-manager';
import { getCookieValue } from '../misc';

const storageManager = StorageManager(LocalStorageManager);

const GLOBAL_MESSAGE_SESSION = 'global-messsage';

const getNameSession = id => {
    return GLOBAL_MESSAGE_SESSION+'#'+id;
}

const getTimesShowed = id => {
    return parseInt(storageManager.get(getNameSession(id)) || 0);
}

const addTimeShowed = (id) => {
    storageManager.addTimes(getNameSession(id));
}

ComponentModule.AddModule('.global-message', {
    prefix: 'global-message-',
    components: [
        {
            props: {
                showTimes: Number
            },
            name: 'template',
            data: () => ({
                isShow: false,
            }),
            mounted: function() {
                const el = this.$parent.$el;

                if (sessionStorage && el.className.includes("__show-times") && el.id) {
                    const times = getTimesShowed(el.id);
                    const showTimes = this.showTimes || 1;
                    if (times >= showTimes) {
                        return;
                    } else {
                        this.isShow = true;
                        this.$nextTick(() => {
                            this.checkOneTrust();
                        })
                    }
                } else {
                    this.isShow = true;
                    this.$nextTick(() => {
                        this.checkOneTrust();
                    })
                }
            },
            methods: {
                close() {
                    const el = this.$parent.$el;

                    this.isShow = false;

                    if (sessionStorage && el.className.includes("__show-times") && el.id) {
                        addTimeShowed(el.id);
                    }

                    const event = new Event('closeGlobalAlert');
                    el.dispatchEvent(event);
                },
                checkOneTrust() {
                    let oneTrustCookie = getCookieValue('OptanonAlertBoxClosed');
                    console.log(this.$el);
                    if (oneTrustCookie == '') {
                        this.$el.style.display = 'none';
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.init();
                            }, 1000);
                        })
                    } else {
                        this.$el.style.display = 'block';
                    }
                },
                init() {
                    let close = document.querySelector('#onetrust-close-btn-container');
                    const el = this.$parent.$el;
                    const openEvent = new Event('openGlobalAlert');
                    if (close) {
                        close.addEventListener('click', () => {
                            el.dispatchEvent(openEvent);
                            this.$el.style.display = 'block';
                        });
                    }
                }
            }
        }
    ]
});

